import React, {Component} from 'react';
import MatchWhenLoggedIn from './../MatchWhenLoggedIn';
import {Route, Redirect} from 'react-router-dom';
import RubricaListSwitcher from './RubricaListSwitcher';
import RubricaView from './RubricaView';
import RubricaFormAll from './RubricaFormAll';


class RubricaContent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (<div>
      <Route exact path='/app/rubrica' render={() => (
          <Redirect
              to='/app/rubrica/list'
          />
      )} />
      <MatchWhenLoggedIn path='/app/rubrica/list' component={RubricaListSwitcher} />
      <MatchWhenLoggedIn path='/app/rubrica/view/:id' component={RubricaView} />
        <MatchWhenLoggedIn path='/app/rubrica/edit/:id' component={RubricaFormAll} />
        <MatchWhenLoggedIn path='/app/rubrica/new' component={RubricaFormAll} />


    </div>)
  }
}

export default RubricaContent;




/** WEBPACK FOOTER **
 ** ./src/components/rubrica/RubricaContent.js
 **/